import Home from './Pages/Home'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './Component/Header'
import Footer from './Component/Footer'
import About from './Pages/about';
import AimObj from './Pages/aimObj';
import CbseInfo from './Pages/cbseInfo';
import Visionmission from './Pages/visionmission';
import Manager from './Pages/manager';
import PrincipalDesk from './Pages/principal';
import Headgirl from './Pages/headgirl';
import Headboy from './Pages/headboy';
import Smc from './Pages/smc';
import SchoolAnthem from './Pages/schoolAnthem';
import SchoolPrayer from './Pages/schoolPrayer';
import Library from './Pages/library';
import Laboratory from './Pages/laboratory';
import Music from './Pages/music';
import ClassActivity from './Pages/classActivity';
import Games from './Pages/games';
import Uniform from './Pages/uniform';
import Ptm from './Pages/ptm'; 
import RulesReg from './Pages/rulesReg';
import Withdrawal from './Pages/withdrawal';
import ParentCorner from './Pages/parentCorner';
import AssessmentsPromo from './Pages/assessmentsPromo';
import OurPrincipals from './Pages/ourPrincipal';
import StaffPhotos from './Pages/staffPhotos';
import SchoolCabinet from './Pages/schoolCabinet';
import MandatoryDisclosure from './Pages/mandatoryDisclosure';
import Fee from './Pages/fee';
import AttendanceLeaveAbsence from './Pages/attendanceLeaveAbsence';
import PhotoGallery from './Pages/gallery';
import Contact from './Pages/contact';
import News from './Pages/news';
import Events from './Pages/events';
import Tc from './Pages/Tc';
import TopperX from './Pages/topperX';
import TopperXII from './Pages/topperXII';
import SubGallery from './Pages/subGallery';
import ERPSoftware from './Pages/ERPSoftware';
import Pphelp from './Pages/pphelp';
import VideoGallery from './Pages/videoGallery';
function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/aimObj" element={<AimObj />} />
          <Route path="/cbseInfo" element={<CbseInfo />} />
          <Route path="/visionmission" element={<Visionmission />} />
          <Route path="/manager" element={<Manager />} />
          <Route path="/principal" element={<PrincipalDesk />} />
          <Route path="/headgirl" element={<Headgirl />} />
          <Route path="/headboy" element={<Headboy />} />
          <Route path="/principal" element={<PrincipalDesk />} />
          <Route path="/smc" element={<Smc />} />
          <Route path="/schoolAnthem" element={<SchoolAnthem />} />
          <Route path="/schoolPrayer" element={<SchoolPrayer />} />
          <Route path="/library" element={<Library />} />
          <Route path="/laboratory" element={<Laboratory />} />
          <Route path="/music" element={<Music />} />
          <Route path="/classActivity" element={<ClassActivity />} />
          <Route path="/games" element={<Games />} />
          <Route path="/uniform" element={<Uniform />} /> 
          <Route path="/ptm" element={<Ptm />} />
          <Route path="/rulesReg" element={<RulesReg />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/parentCorner" element={<ParentCorner />} />
          <Route path="/assessmentsPromo" element={<AssessmentsPromo />} /> 
          <Route path="/ourPrincipals" element={<OurPrincipals />} /> 
          <Route path="/staffPhotos" element={<StaffPhotos />} /> 
          <Route path="/schoolCabinet" element={<SchoolCabinet />} /> 
          <Route path="/mandatoryDisclosure" element={<MandatoryDisclosure />} /> 
          <Route path="/fee" element={<Fee />} /> 
          <Route path="/attendanceLeaveAbsence" element={<AttendanceLeaveAbsence />} /> 
          <Route path="/photoGallery" element={<PhotoGallery />} /> 
          <Route path="/contact" element={<Contact />} /> 
          <Route path="/news" element={<News />} /> 
          <Route path="/events" element={<Events />} /> 
          <Route path="/Tc" element={<Tc />} /> 
          <Route path="/topperX" element={<TopperX />} /> 
          <Route path="/topperXII" element={<TopperXII />} /> 
          <Route path="/subGallery" element={<SubGallery />} />  
          <Route path="/ERPSoftware" element={<ERPSoftware />} />  
          <Route path="/pphelp" element={<Pphelp />} />  
          <Route path="/videoGallery" element={<VideoGallery />} />  
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  )
}

export default App;
